<template>
  <modal
    width="35"
    :show-modal="showModal"
    @close-modal="closeModal"
    title="Move Lead To Opportunity"
  >
    <div>
      <label class="label">Reason:</label>
      <el-select v-model="payload.objectType" placeholder="Select">
        <el-option
          v-for="reason in reasons"
          :key="reason"
          :label="reason"
          :value="reason"
        >
        </el-option>
      </el-select>
    </div>
    <div>
      <label class="label">Estimate Value:</label>
      <input
        type="text"
        class="input"
        placeholder="Estimated value"
        @keydown="isNumber($event)"
        v-model="payload.objectTotal"
      />
    </div>
    <div>
      <label class="label">Category:</label>
      <el-select v-model="payload.leadCategory" placeholder="Select">
        <el-option
          v-for="category in categories"
          :key="category"
          :label="category"
          :value="category"
        >
        </el-option>
      </el-select>
    </div>
    <div>
      <label class="label">Probability:</label>
      <el-select v-model="payload.leadStatus" placeholder="Select">
        <el-option
          v-for="probability in probabilities"
          :key="probability"
          :label="probability"
          :value="probability"
        >
        </el-option>
      </el-select>
    </div>
    <div class="flex justify-between mt-8 mb-2">
      <div>
        <p class="cursor-pointer" @click="closeModal">Cancel</p>
      </div>
      <div>
        <primary-button
          buttonText="Save"
          :loading="loading"
          @click="moveToOpportunity"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      required: true,
      type: Boolean,
    },
    contact: {
      required: true,
    },
  },
  data() {
    return {
      payload: {
        leadCategory: "",
        leadStatus: "",
        objectTotal: "",
        objectType: "",
      },
      loading: false,
      reasons: [
        "product demo",
        "seminar",
        "workshop",
        "presentation",
        "quote",
        "invoice",
        "receipt",
        "waybill",
        "contract",
      ],
      categories: ["opportunity"],
      probabilities: ["highly likely", "likely", "highly unlikely"],
    };
  },
  methods: {
    async moveToOpportunity() {
      this.loading = true;
      const orgId = localStorage.getItem("organizationId");
      const payload = {
        userInfo: {
          orgId: orgId,
          creatorId: orgId,
          outletId: null,
        },
        payload: {
          contactId: this.contact.id,
          ...this.payload,
        },
      };
      try {
        const response = await this.$_moveLeadToOpportunity(payload);
        this.generateToast(
          "Lead successfully moved to opportunity!",
          "success"
        );
        this.logResponse(response);
        this.$emit("contact-moved");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.label {
  margin-top: 1rem;
}
.input {
  margin-bottom: 0;
}
</style>
